export enum Features {
    DoubleAuth,
    MultiCountry,
    Explorer,
    DeleleMultipleFiles,
    UploadFile,
    DeleteFile
}